import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getPageName } from '../../utils/pageName';
import { BrandHyperlink } from '../../components/button/brand/BrandHyperlink';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { useUser } from '../../user/useUser';

type Props = {
  manualSourcePage?: string;
};

export const NavSignupButton: FC<Props> = ({ manualSourcePage }) => {
  const {
    currentUser: { isSnapshotsCrawler },
  } = useUser();

  const sourcePage = getPageName() || manualSourcePage;
  const shouldHideLink = isSnapshotsCrawler;
  const href = shouldHideLink
    ? undefined
    : buildUrlWithParameters('/inscription', {
        source: 'header',
        sourcePage,
      });

  return (
    <BrandHyperlink data-test-id="link-signup" href={href}>
      <FormattedMessage id="navigation/signup/NavSignupButton.tsx/1" />
    </BrandHyperlink>
  );
};
